import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the tablePagoPremioView.
 * @extends JetView
 */
export default class tablePagoPremioView extends JetView {
    /**
     * Configures the datatable view.
     * @returns {Object} Configuration object for the datatable.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            view: 'datatable', // Specifies the view type
            id: 'tablePagoPremio', // Unique identifier for the datatable
            height: 300, // Height of the datatable
            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
            select: true, // Enables row selection
            columns: [
                // Column definitions for the datatable
                {
                    id: 'Id',
                    header: _('Ticket Det Id'), // Localized header
                    width: 100,
                    sort: 'int', // Sorting type
                },
                {
                    id: 'TicketId',
                    header: _('Ticket ID'),
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'Description',
                    header: _('Descripción'),
                    width: 200,
                    sort: 'int',
                },
                { id: 'Market', header: _('Market'), width: 100, sort: 'int' },
                { id: 'Option', header: 'Option', width: 200, sort: 'int' },
                {
                    id: 'Odds',
                    header: _('Odds'),
                    width: 100,
                    format: webix.i18n.numberFormat, // Number formatting for odds
                    sort: 'int',
                },
                {
                    id: 'Usuario',
                    header: _('Usuario'),
                    width: 150,
                    sort: 'int',
                },
            ],
            footer: true, // Enables footer
            math: true, // Enables mathematical operations in footer
            loadahead: devConfig.getDefaultDataFetch(), // Data fetching configuration
            pager: 'pagerA', // Identifier for the pager
            url: devConfig.geturlApi() + 'Report/GetBetHistoryDetail', // API endpoint for data
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        $$('tablePagoPremio').hide(); // Hides the datatable initially
        $$('pagerA').hide(); // Hides the pager initially
        this.on(this.app, 'pagoPremio:filter', (filterData) => {
            // Event listener for filtering data
            var object = Object.entries(filterData); // Converts filterData to an array of entries
            var string1 = '&id=' + filterData.NoTicket; // Constructs query string for ticket ID
            console.log(string1); // Logs the constructed query string
            grid.load(
                // Loads data into the grid
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + string1,
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event listener for item click
            var item = this.getItem(id); // Retrieves the clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Calls an event with the item ID
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                // Loads data based on selected player ID
                grid.data.url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id,
            );
        });
    }
}

// FILE DOCUMENTED
